module.exports = __webpack_public_path__ + "static/img/picture22.0b3842a7.png";